import { useNavigate } from 'react-router-dom';

const useRedirect = () => {
  const navigate = useNavigate();
  return (path: string) => navigate(path);
};

export default useRedirect;
